// extracted by mini-css-extract-plugin
export default {"defaultConfettiContainer":"defaultConfettiContainer-4-M76t"};